export class RegistrationRetailerAccountViewModel {
  estimatedNumberOfUsers: number;
  supplierNumber: string;
  usersHaveBadges: boolean;
  usersAreDirectlyEmployed: boolean;
  usersAreMobileEnabled: boolean;
  usersHaveUniqueEmails: boolean;
}
